export const HOW_TO_PLAY_URL = window.location.origin + '/how-to-play.pdf';
